const envConfig = function (key) {
  if (window.vueConfig && window.vueConfig[key] !== null && window.vueConfig[key] !== undefined) {
    return window.vueConfig[key]
  }
  return process.env[key]
}
export default envConfig
